import { jwtDecode } from "jwt-decode"
import api from "../../../utilities/interseptor"
import Swal from "sweetalert2";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API



export const getPermisos = (setMenuFiltradoPorPermisos, menuDataJson) => {
    const token = sessionStorage.getItem("token")
    const tokenDecode = jwtDecode(token)


    api.get(apiUrl + `/monitor/permisos/getPermisos?id_usuario=${tokenDecode.ID}`)
        .then((res) => {

            // preparamos un arreglo con los permisos
            const modulosIds = res.data.map(item => item.MODULO);
            // Filtrar los submenús por los módulos seleccionados
            // const filtrado = menuDataJson.reduce((acc, item) => {
            //     // Filtrar los submenús del ítem actual
            //     const subMenusFiltrados = item.subMenu.filter(sub => modulosIds.includes(sub.modulo));

            //     // Si el submenú tiene elementos que coinciden, los añadimos
            //     if (subMenusFiltrados.length > 0) {
            //         acc.push({
            //             ...item,
            //             subMenu: subMenusFiltrados // Solo incluimos los submenús filtrados
            //         });
            //     }

            //     return acc;
            // }, []);
            const filtrado = menuDataJson.reduce((acc, item) => {
                const subMenusFiltrados = item.subMenu.filter(sub => modulosIds.includes(sub.modulo));
                // Si el menú principal tiene el módulo o algún submenú coincide, lo agregamos
                if (modulosIds.includes(item.modulo) || subMenusFiltrados.length > 0) {
                    acc.push({
                        ...item,
                        subMenu: subMenusFiltrados
                    });
                }
                return acc;
            }, []);


            // if (modulosIds.includes(8)) {
            //     filtrado.push(menuDataJson[2])
            // }
            // if (modulosIds.includes(9)) {
            //     filtrado.push(menuDataJson[3])
            // }
            console.log("filtrado", filtrado);
            console.log("menuDataJson", menuDataJson);

            setMenuFiltradoPorPermisos(filtrado)
            // en caso de no encontrar permisos
            if (filtrado.length == 0) {
                Swal.fire({
                    icon: 'error',   // Icono de error
                    text: 'Usted no cuenta con ningun permiso en esta plataforma, favor de contactar con el personal de I+D', // Mensaje de error
                    confirmButtonText: 'OK'  // Texto del botón de confirmación
                });
            }

        })
        .catch((error) => {
            console.log("error", error);

        })

}

export const getDb = (setDb) => {
    api.get(apiUrl + `/monitor/permisos/getdb`).then((res) => {

        setDb(res.data)

    })
        .catch((error) => {
            console.log("setDb", error);

        })
}